import PostsCustomer from "./PostCustomer/posts";
import { Outlet, useParams } from "react-router-dom";

const Tab4 = ({ routeBase = "/customer/posts" }) => {
  const { Id } = useParams();

  return Id ? <Outlet /> : <PostsCustomer routeBase={routeBase} />;
};

export default Tab4;
